import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2'; import { Key, Plus } from 'lucide-react';

function LlamaApiKeyManagePage() {
  const [apiKeys, setApiKeys] = useState([]);
  const [showApiKeyModal, setShowApiKeyModal] = useState(false);
  const [editingApiKey, setEditingApiKey] = useState(false);
  const [apiKeyForm, setApiKeyForm] = useState({
    id: null,
    name: '',
    api_key: '',
    provider: 'llama_cloud',
    is_active: '1',
    priority_order: '0',
  });

  const fetchApiKeys = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/admin/rag-api-keys`, {
        withCredentials: true,
      });
      setApiKeys(response.data.data || []);
    } catch (error) {
      Swal.fire('Oops!', error.response?.data?.message || 'Gagal memuat API Keys.', 'error');
    }
  };

  useEffect(() => {
    fetchApiKeys();
  }, []);

  const openApiKeyModal = (apiKey = null) => {
    if (apiKey) {
      setApiKeyForm({
        id: apiKey.id,
        name: apiKey.name,
        api_key: '',
        provider: 'llama_cloud',
        is_active: String(apiKey.is_active ? 1 : 0),
        priority_order: String(apiKey.priority_order || 0),
      });
      setEditingApiKey(true);
    } else {
      setApiKeyForm({
        id: null,
        name: '',
        api_key: '',
        provider: 'llama_cloud',
        is_active: '1',
        priority_order: '0',
      });
      setEditingApiKey(false);
    }
    setShowApiKeyModal(true);
  };

  const handleApiKeyChange = (event) => {
    const { name, value } = event.target;
    setApiKeyForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleApiKeySubmit = async (event) => {
    event.preventDefault();

    try {
      if (editingApiKey) {
        await axios.put(
          `${process.env.REACT_APP_API_BASE_URL}/admin/rag-api-keys/${apiKeyForm.id}`,
          apiKeyForm,
          { withCredentials: true }
        );
      } else {
        await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/admin/rag-api-keys`,
          apiKeyForm,
          { withCredentials: true }
        );
      }

      setShowApiKeyModal(false);
      await fetchApiKeys();
      Swal.fire('Berhasil', `API key berhasil ${editingApiKey ? 'diperbarui' : 'ditambahkan'}.`, 'success');
    } catch (error) {
      Swal.fire('Oops!', error.response?.data?.message || 'Gagal menyimpan API key.', 'error');
    }
  };

  const handleDeleteApiKey = async (id) => {
    const result = await Swal.fire({
      title: 'Hapus API key ini?',
      text: 'Data key akan dihapus dari database.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ya, hapus',
      cancelButtonText: 'Batal',
    });

    if (!result.isConfirmed) return;

    try {
      await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/admin/rag-api-keys/${id}`, {
        withCredentials: true,
      });
      await fetchApiKeys();
      Swal.fire('Berhasil', 'API key berhasil dihapus.', 'success');
    } catch (error) {
      Swal.fire('Oops!', error.response?.data?.message || 'Gagal menghapus API key.', 'error');
    }
  };

  return (
    <div className="container-fluid px-0">
      <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
        <div className="mb-4 d-flex flex-wrap align-items-center justify-content-between gap-3">
          <div className="flex items-center gap-2 text-slate-800">
            <Key size={18} />
            <h4 className="mb-0 text-lg font-semibold">Daftar API Key</h4>
          </div>
          <button className="btn btn-dark d-inline-flex align-items-center gap-2" onClick={() => openApiKeyModal()}>
            <Plus size={16} /> Tambah Key
          </button>
        </div>

        <div className="table-responsive rounded-xl border border-slate-300 bg-white">
          <table className="table table-hover table-striped table-bordered table-sm align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th>Nama</th>
                <th>Key</th>
                <th className="text-center">Prioritas</th>
                <th className="text-center">Status</th>
                <th className="text-center">Usage</th>
                <th>Last Used</th>
                <th className="text-center">Aksi</th>
              </tr>
            </thead>
            <tbody>
              {apiKeys.length === 0 ? (
                <tr>
                  <td colSpan="7" className="text-center text-muted py-3">
                    Belum ada Llama Cloud API key.
                  </td>
                </tr>
              ) : (
                apiKeys.map((item) => (
                  <tr key={item.id}>
                    <td>
                      <div className="fw-semibold">{item.name}</div>
                      <div className="small text-muted">llama_cloud</div>
                    </td>
                    <td>
                      <code>{item.api_key_masked}</code>
                      {item.last_error ? (
                        <div className="small text-danger mt-1">{item.last_error}</div>
                      ) : null}
                    </td>
                    <td className="text-center">{item.priority_order}</td>
                    <td className="text-center">
                      <span className={`badge ${item.is_active ? 'bg-success' : 'bg-secondary'}`}>
                        {item.is_active ? 'AKTIF' : 'NONAKTIF'}
                      </span>
                    </td>
                    <td className="text-center">{item.usage_count || 0}</td>
                    <td>{item.last_used_at ? new Date(item.last_used_at).toLocaleString('id-ID') : '-'}</td>
                    <td className="text-center">
                      <div className="d-flex justify-content-center gap-2">
                        <button className="btn btn-sm btn-outline-dark" onClick={() => openApiKeyModal(item)}>
                          <i className="fa fa-edit"></i>
                        </button>
                        <button className="btn btn-sm btn-outline-danger" onClick={() => handleDeleteApiKey(item.id)}>
                          <i className="fa fa-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showApiKeyModal ? (
        <div className="modal d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <form onSubmit={handleApiKeySubmit}>
                <div className="modal-header">
                  <h5 className="modal-title">{editingApiKey ? 'Edit Llama Cloud API Key' : 'Tambah Llama Cloud API Key'}</h5>
                  <button type="button" className="btn-close" onClick={() => setShowApiKeyModal(false)}></button>
                </div>
                <div className="modal-body row g-3">
                  <div className="col-12">
                    <label className="form-label">Nama Key</label>
                    <input type="text" className="form-control" name="name" value={apiKeyForm.name} onChange={handleApiKeyChange} required />
                  </div>
                  <div className="col-12">
                    <label className="form-label">
                      Llama Cloud API Key {editingApiKey ? <span className="small text-muted">(Kosongkan jika tidak diubah)</span> : null}
                    </label>
                    <textarea className="form-control" rows="4" name="api_key" value={apiKeyForm.api_key} onChange={handleApiKeyChange} required={!editingApiKey}></textarea>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Provider</label>
                    <input type="text" className="form-control" name="provider" value={apiKeyForm.provider} onChange={handleApiKeyChange} readOnly />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Prioritas</label>
                    <input type="number" className="form-control" name="priority_order" value={apiKeyForm.priority_order} onChange={handleApiKeyChange} />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Status</label>
                    <select className="form-control" name="is_active" value={apiKeyForm.is_active} onChange={handleApiKeyChange}>
                      <option value="1">Aktif</option>
                      <option value="0">Nonaktif</option>
                    </select>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="submit" className="btn btn-dark">{editingApiKey ? 'Update' : 'Simpan'}</button>
                  <button type="button" className="btn btn-secondary" onClick={() => setShowApiKeyModal(false)}>Tutup</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default LlamaApiKeyManagePage;
